import React from "react";
import Animation from "./loadin_gif.gif";
import styled from "styled-components/macro";

const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`;

const Loading = () => {
  return (
    <React.Fragment>
      <Root>
        <img src={Animation} style={{ display: "block", margin: "auto" ,height:"500px"}} alt="loading"  />
      </Root>
    </React.Fragment>
  );
};

export default Loading;
